import React from "react";
import CompanyLogo from "../../common/CompanyLogo";

const TermsAndCondition = () => {
  return (
    <div className="w-full">
      <CompanyLogo
        title={"Terms & Conditions"}
        subtitle={"Terms & Conditions"}
      />
      <h1 className="text-3xl font-semibold  p-2 md:p-0 mt-4 w-full md:w-[91%] xl:[84%] 2xl:w-[75%] mx-auto">
        Terms
        <hr className="md:mt-4" />
      </h1>
      <div className="w-full md:w-[91%] xl:[84%] 2xl:w-[75%] mx-auto space-y-7 p-2 md:p-0">
        <div>
          <h2 className="text-xl text-text_color font-semibold py-3 ">
            General
          </h2>
          <p>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has survived not
            only five centuries, but also the leap into electronic typesetting,
            remaining essentially unchanged.
          </p>
        </div>
        <div>
          <h2 className="text-xl text-text_color font-semibold py-3 ">
            Disclaimer Notice
          </h2>
          <div className="text-subtext_color">
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
          </div>
        </div>
        <div>
          <h2 className="text-xl text-text_color font-semibold py-3 ">
            Legal Disclaimer
          </h2>
          <div className="text-subtext_color">
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
            <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
          </div>
        </div>
        <div>
          <h2 className="text-xl text-text_color font-semibold py-3 ">
            Email/Newsletter Subscription and Membership obligations
          </h2>
          <div className="text-subtext_color">
            <li>
              In case you join our community or submit for a newsletter/
              membership subscription or opt to receive emails from the Site,
              the details you enter on the registration form will be used by us
              to provide you with franchise industry newsletters and/or special
              promotions and other information. If at any time you wish opt-out
              of receiving these e-mails, simply follow the unsubscribing
              instructions given at the bottom of the e-mail. By submitting
              details to the Site and asking us to disclose your information to
              advertisers, you agree to receive telephone calls and/or emails
              about franchise and business opportunities even if you are
              registered with us or anywhere in the Do Not Call List. You agree
              to provide your real name, last name and accurate and truthful
              personal information in your registration.
            </li>
            <li>
              You agree to keep your username and password safe from use by
              third parties and not to share your registration details with
              anyone else.
            </li>
            <li>
              You agree to indemnify the Company against any unauthorised use of
              your username and password, howsoever caused
            </li>
            <li>
              We reserve the right to modify the membership information you
              provide, as well as to delete, disable and/or restrict your
              account in our absolute discretion.
            </li>
          </div>
        </div>
        <div>
          <h2 className="text-xl text-text_color font-semibold py-3 ">
            Refund Policy
          </h2>
          <div className="text-subtext_color">
            <li>Refund will take maximum 30 Business days.</li>
            <li>
              A minimum of 75 days cancellation notice before event is required
              to be given; in the absence of the same, no refund will be
              processed. Annual package deals will not be a part of this.
            </li>
            <li>
              Cheque payments will be refunded via cheque, payable to the person
              or organization named on the original cheque presented for
              payment.
            </li>
            <li>
              Credit Card payments will be refunded to the original credit card
              presented for payment.
            </li>
          </div>
        </div>
        <div>
          <h2 className="text-xl text-text_color font-semibold py-3 ">
            Variation
          </h2>
          <div className="text-subtext_color">
            <li>
              We reserve the right to amend or modify these Terms and Conditions
              at any time without notice..
            </li>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndCondition;
